import gql from "graphql-tag";

// Staff props
const StaffDrugProps = gql`
    fragment StaffDrugProps on Staff {
        id
        surname
        first_name
        middle_name
        email
        type {
            id
            name
        }
        designation {
            id
            name
        }
        department {
            id
            name
        }
        image
    }
`;

// Drug Chart Prop
const DrugChartProps = gql`
    fragment DrugChartProps on DrugChart {
        id
        prescriptions {
            prescriptionId
            active
            dose
            drugName
            frequency
            initial
            instruction
            startDate
            stopDate
            pharmacy
            route
            intakes {
                author {
                    id
                    surname
                    first_name
                    middle_name
                    designation {
                        id
                        name
                    }
                }
                dose
                initial
                note
                datetime
            }
        }
        author {
            ...StaffDrugProps
        }

        active
    }
    ${StaffDrugProps}
`;

const LIST = gql`
    query GetDrugCharts($id: ID!) {
        GetDrugCharts(id: $id) {
            docs {
                ...DrugChartProps
            }
        }
    }
    ${DrugChartProps}
`;
const CREATE = gql`
    mutation RecordChart($model: DrugChartInput!) {
        RecordNewDrugChart(model: $model) {
            message
            doc {
                ...DrugChartProps
            }
        }
    }
    ${DrugChartProps}
`;

const INTAKE = gql`
    mutation UpdateIntake($id: ID!, $update: DrugIntakeInput!) {
        RecordDrugAdministration(id: $id, update: $update) {
            message
            doc {
                ...DrugChartProps
            }
        }
    }
    ${DrugChartProps}
`;
export { LIST, CREATE, INTAKE };
